import { styled } from 'styled-components';

interface CoverProps {
    background?: string;
    height?: string;
}
type iconTypeProps ='square' | 'rectangle'
interface IconProps {
    type?: iconTypeProps;
}

interface ProductCardBoxProps {
    hasIcon: boolean;
}

export const ActionButtonsWrapper = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    gap: 6px;
`;

export const CardActionButton = styled.button<{ $variant?: 'default' | 'danger' }>`
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.card.background};
    border-radius: 6px;
    border: none;
    transition: all 0.2s ease-in-out;
    opacity: 0.85;

    svg {
        color: ${({ theme, $variant }) => ($variant === 'danger'
    ? theme.colors.danger[500]
    : theme.colors.text.secondary)};
    }

    &:hover {
        opacity: 1;
        background: ${({ theme, $variant }) => {
    if ($variant === 'danger') {
      return theme.mode === 'dark' ? 'rgba(239, 68, 68, 0.2)' : '#fef2f2';
    }
    return theme.mode === 'dark' ? '#374151' : '#f3f4f6';
  }};
        transform: translateY(-1px);
    }

    &:active {
        transform: scale(0.95);
    }
`;

export const CardConferenceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    cursor: pointer;
`;

export const Cover = styled.div<CoverProps>`
    width: 100%;
    height: ${(props) => props.height || '200px'};
    overflow: hidden;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-image: url(${(props) => props.background});
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
`;

export const CardConferenceBox = styled.div<ProductCardBoxProps>`
    width: 100%;
    height: 200px;
    background: ${({ theme }) => theme.colors.card.background};
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};
    padding:  ${(props) => (props.hasIcon ? '35px 20px 15px 20px' : '15px 20px')};
    position:relative;
`;

export const Title = styled.h3`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.primary};
    line-height: 1.7;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Description = styled.p`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.secondary};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;
export const Subtitle = styled.p`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.text.primary};
    margin:0!important;
`;

export const IconWrapper = styled.div<IconProps>`
    width: 50px;
    height: 50px;
    position: absolute;
    top:-25px;
    left: 15px;
    border-radius: ${(props) => (props.type === 'square' ? '50%' : '6px')};
    background: ${({ theme }) => theme.colors.card.background};
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const IconAttachmentWrapper = styled.div<IconProps>`
    width: 50px;
    height: 50px;
    position: absolute;
    top:15px;
    left: 15px;
    border-radius: ${(props) => (props.type === 'square' ? '50%' : '6px')};
    background: ${({ theme }) => (theme.mode === 'dark' ? '#fff' : '#000')};
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BubleWhite = styled.div`
    width: 18px;
    height: 18px;
    top:15px;
    right: -8px;
    z-index: 2;
    background: ${({ theme }) => theme.colors.card.background};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 50%;
    position: absolute;
`;

export const WhiteWrapper = styled.div`
    width: 24px;
    height: 24px;
    top:15px;
    right: -8px;
    z-index: 10;
    background: ${({ theme }) => theme.colors.card.background};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 50%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const BubleBlack = styled.div`
    width: 18px;
    height: 18px;
    top:15px;
    right: -8px;
    z-index: 2;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#fff' : '#000')};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 50%;
    position: absolute;
`;

export const TagWrapper = styled.div`
    width: 100%;
    height: 30px;
    padding: 2px 8px;
    border-radius: 6px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e5e5')};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: ${({ theme }) => theme.colors.text.secondary};
    gap: 5px;
    font-size: 12px;
`;

export const StatusWrapper = styled.div`
    position: absolute;
    top: 10px;
    left: 15px;
`;
